export const PRIVACY_POLICY_URL = 'https://giftee.co.jp/privacypolicy/'
export const BULK_ORDER_TEWATASHI_FORM_URL =
  'https://form.run/@bulk-order-tewatashi'
